import { Fragment } from 'react';
import SkeletonBox from 'conversations-skeleton-state/components/SkeletonBox';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CallNumberSkeletons = () => /*#__PURE__*/_jsxs(Fragment, {
  children: [[...Array(3)].map((e, i) => /*#__PURE__*/_jsxs("div", {
    className: "m-x-3 m-top-3 m-bottom-0",
    children: [/*#__PURE__*/_jsx(SkeletonBox, {
      width: 16,
      height: 16,
      className: "m-right-1 display-inline-block"
    }), /*#__PURE__*/_jsx(SkeletonBox, {
      width: 24,
      height: 16,
      className: "m-right-1 display-inline-block"
    }), /*#__PURE__*/_jsx(SkeletonBox, {
      width: 120,
      height: 16,
      className: "m-right-1 display-inline-block"
    }), /*#__PURE__*/_jsx(SkeletonBox, {
      width: 80,
      height: 16,
      className: "m-right-1 display-inline-block"
    })]
  }, `number-placeholder_${i}`)), /*#__PURE__*/_jsx("div", {
    className: "m-all-3",
    "data-selenium-test": "calling-skeleton-state",
    children: /*#__PURE__*/_jsx(SkeletonBox, {
      width: 180,
      height: 16,
      className: "m-right-1 display-inline-block"
    })
  })]
});
export default CallNumberSkeletons;